<template>
    <div :class="wrapperClassNames" class="llp-button">
        <!-- <button :class="classNames" :disabled="loadSpinner || disabled" :type="type" class="btn text-uppercase" -->
          <button :class="classNames" :disabled="loadSpinner || disabled" :type="type" class="btn"
                @click="$emit('click:button',$event)">
            <span v-if="loadSpinner" aria-hidden="true" class="spinner-border spinner-border-sm mx-1"
                  role="status"></span>
            <slot></slot>
        </button>
    </div>
</template>

<script>

export default {
  name: 'BaseButton',
  props: {
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    wrapperClassNames: {
      type: String,
      required: false,
      default: 'd-grid',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadSpinner: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: 'button',
    },
  },
};
</script>
